import { render, staticRenderFns } from "./ManageRepresentatives.vue?vue&type=template&id=33a52cb8"
import script from "./ManageRepresentatives.vue?vue&type=script&lang=js"
export * from "./ManageRepresentatives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports